import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Wrapper = styled.div`
  background-color: var(--swatch3);
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.m} 0;

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) =>
      `${props.theme.spacing.l} 0 ${props.theme.spacing.xl}`};
  }

  @media (max-width: ${mobileBreakPointCSS}) {
    .order-card,
    table {
      margin-left: -${(props) => props.theme.spacing.m};
      margin-right: -${(props) => props.theme.spacing.m};
      border-radius: 0 !important;
    }

    table {
      width: 100vw;
    }
  }
`;

export const Title = styled.h1.attrs({ className: "h2" })`
  margin: ${(props) => `0 0 ${props.theme.spacing.l}`};
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.l};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
  }
`;

export const Menu = styled.nav`
  display: flex;
  gap: ${(props) => props.theme.spacing.s};
  padding: 0 ${(props) => props.theme.spacing.m};
  margin-bottom: ${(props) => props.theme.spacing.l};
  overflow-x: auto;

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: column;
    padding: 0;
    margin-bottom: 0;
  }
`;

export const Link = styled.a.attrs({ className: "h5" })<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  background-color: #fff;
  color: var(--swatch2);
  text-decoration: none;
  height: 63px;
  width: 270px;
  padding: 0 ${(props) => props.theme.spacing.m};
  border-radius: ${(props) => props.theme.borderRadius};
  white-space: nowrap;

  ${(props) =>
    props.$active &&
    css`
      background-color: var(--swatch2);
      color: #fff;
    `}
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};
`;

export const Card = styled.div`
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => `${props.theme.spacing.l} ${props.theme.spacing.m}`};

  &:nth-child(even) {
    border-radius: ${(props) => props.theme.borderRadius};
  }

  &:nth-child(odd) {
    border-radius: ${(props) => props.theme.borderRadius};
  }

  > *:first-child {
    margin-top: 0;
  }

  button:last-child {
    margin-top: ${(props) => props.theme.spacing.l};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.l};
  }
`;

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const MobileOrders = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};
  position: relative;

  > a {
    display: block;
    background-color: #fff;
    color: var(--swatch2);
    text-decoration: none;
    padding: ${(props) => props.theme.spacing.m};
    padding-right: 76px;
  }

  h3 {
    margin: 0 0 ${(props) => props.theme.spacing.s};
  }

  i {
    position: absolute;
    right: ${(props) => props.theme.spacing.m};
    bottom: ${(props) => props.theme.spacing.m};
  }
`;

export const StyledOrderTable = styled.table<{ $iconTail?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  border-spacing: 0;

  th,
  td {
    text-align: center;
    padding: ${(props) => `${props.theme.spacing.s} ${props.theme.spacing.m}`};
  }

  th {
    background-color: var(--swatch1);
    color: #fff;
    padding-top: ${(props) => props.theme.spacing.xs};
    padding-bottom: ${(props) => props.theme.spacing.xs};
  }

  td {
    border-bottom: 1px solid var(--swatch1);
  }

  td p {
    margin: 0;
  }

  tfoot td {
    border-bottom: none;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ${(props) =>
    props.$iconTail
      ? css`
          th:nth-last-child(2),
          td:nth-last-child(2) {
            text-align: right;
          }
        `
      : css`
          th:last-child,
          td:last-child {
            text-align: right;
          }
        `}

  .image-td {
    display: flex;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
      margin-right: ${(props) => props.theme.spacing.s};
      object-fit: contain;
    }
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    th,
    td {
      padding: ${(props) => props.theme.spacing.m};
    }
  }
`;

export const IconLink = styled.a`
  display: block;
  text-decoration: none;
  width: 27px;
  height: 28px;

  path {
    fill: var(--swatch2);
  }
`;

export const Sum = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: right;
  gap: ${(props) => props.theme.spacing.xs};

  div {
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing.xs};
  }

  p {
    margin: 0;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.m};

    div {
      gap: ${(props) => props.theme.spacing.xs};
    }
  }
`;

export const ContactCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  img {
    display: block;
    width: 240px;
    height: 240px;
    border-radius: ${(props) => props.theme.borderRadius};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.l};
    flex-direction: row;

    > *:last-child {
      margin-top: ${(props) => props.theme.spacing.l};
    }
  }
`;

export const FormField = styled.div<{ $last?: boolean }>`
  ${(props) =>
    !props.$last &&
    css`
      margin-bottom: ${(props) => props.theme.spacing.m};
    `};
`;

export const FormError = styled.div`
  color: #fff;
  background-color: var(--error);
  padding: ${(props) => `${props.theme.spacing.s} ${props.theme.spacing.s}`};
  margin-top: ${(props) => props.theme.spacing.m};
  border-radius: ${(props) => props.theme.borderRadius};

  p {
    margin: 0;
  }
`;

export const FormSuccess = styled.div`
  text-align: center;
  width: 100%;
  padding: ${(props) => props.theme.spacing.m};
  box-sizing: border-box;
`;
